import { engagementDefinitions } from './index';
import { AnimatePresence, motion } from 'motion/react';
import { useScreenTheme } from '@/providers/ScreenThemeStateProvider/EventScreenThemeContext';

export function StageActiveEngagement() {
  const {
    state: { activeEngagement: engagement },
  } = useScreenTheme();

  if (!engagement) return null;

  const EngagementDefinition = engagementDefinitions[engagement.type];
  const Component = EngagementDefinition?.stageComponent;

  if (!Component) {
    throw new Error(`No stage component for ${engagement.type}`);
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        className="h-full min-h-0 w-full"
        key={engagement.type}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -20 }}
        transition={{ duration: 0.3 }}
      >
        <Component key={engagement.id} engagement={engagement} />
      </motion.div>
    </AnimatePresence>
  );
}
